<template>
  <a-row class="project-tasks-counter">
    <a-col class="tasks-counter total">
      <h4>Всего задач</h4>
      <span class="tasks-counter__num">{{ total }}</span>
    </a-col>
    <a-col class="tasks-counter incomplete">
      <h4>В работе</h4>
      <span class="tasks-counter__num">{{ incompleteCount }}</span>
    </a-col>
    <a-col class="tasks-counter completed">
      <h4>Выполнено</h4>
      <span class="tasks-counter__num">{{ completedCount }}</span>
    </a-col>
    <a-col class="tasks-counter completed_overdue">
      <h4>Просрочено</h4>
      <span class="tasks-counter__num">{{ completedOverdueCount }}</span>
    </a-col>
    <a-col class="tasks-counter incomplete_overdue">
      <h4>Не выполнено</h4>
      <span class="tasks-counter__num">{{ incompleteOverdueCount }}</span>
    </a-col>
  </a-row>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    completedCount: {
      type: Number,
      default: 0,
    },
    completedOverdueCount: {
      type: Number,
      default: 0,
    },
    incompleteCount: {
      type: Number,
      default: 0,
    },
    incompleteOverdueCount: {
      type: Number,
      default: 0,
    },
  });

  const total = computed(() => {
    return (
      props.completedCount +
      props.completedOverdueCount +
      props.incompleteCount +
      props.incompleteOverdueCount
    );
  });
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .project-tasks-counter {
    flex-wrap: nowrap;
    height: 159px;

    .tasks-counter {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 10px;
      width: 100%;

      &.total {
        background-color: $color-bg-seconary-black-95;
      }

      &.incomplete {
        background-color: $color-btn-secondary;
        h4 {
          color: $color-bg-primary-black-100;
        }

        .tasks-counter__num {
          color: $color-bg-primary-black-100;
        }
      }

      &.completed {
        background-color: $color-bg-status-done;
      }

      &.completed_overdue {
        background-color: $color-bg-status-expired;
      }

      &.incomplete_overdue {
        background-color: $color-bg-status-reject;
      }

      h4 {
        color: $color-bg-primary-white;
      }

      &__num {
        color: $color-bg-primary-white;
        font-size: 62px;
        font-weight: 700;
        line-height: 72px;
      }
    }
  }
</style>
